import { defineMessages } from 'react-intl';

const trns = defineMessages({
  homeBreadCrumb: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  catalogBreadCrumb: {
    id: 'FCddpq',
    defaultMessage: 'Каталог ліків'
  },
  showCategories: {
    id: 'xoj35u',
    defaultMessage: 'Показати всі категорії'
  },
  hideCategories: {
    id: '8QG9eF',
    defaultMessage: 'Згорнути категорії'
  },
  categoryPrice: {
    id: '4ldGKz',
    defaultMessage: 'Ціни на'
  },
  drugInCity: {
    id: '845jRR',
    defaultMessage: 'Ціни на «{tradeName}» в аптеках міста'
  },
  name: {
    id: 'EN/rl9',
    defaultMessage: 'Назва'
  },
  price: {
    id: 'dLUDWs',
    defaultMessage: 'Ціна'
  }
});

export default trns;
